(ns quuppa.qsm.register-qpe.view
  ;; TODO: Move under quuppa.qsm.qpes.*?
  (:require [clojure.string :as str]
            [re-frame.core :as rf]
            [quuppa.components :as c]
            [quuppa.date-time.core :as date-time]
            quuppa.qsm.register-qpe.events
            quuppa.qsm.register-qpe.subs
            [quuppa.qsm.common.subs :as subs]
            [quuppa.qsm.register-qpe.utils :as register-qpe-utils]
            [quuppa.ui.layout :as layout]))

(defn coerse-proxy-config
  "Removes `:proxy-host` and `:proxy-port` keys if they are empty strings.
  Parses `:proxy-port` into a number"
  [data]
  (let [data (if-not (seq (get data :proxy-host))
               (dissoc data :proxy-host)
               data)
        data (update data :proxy-port #(if %
                                         (js/parseInt %)
                                         %))
        data (if-not (get data :proxy-port)
               (dissoc data :proxy-port)
               data)]
    data))

(defn sidebar-form []
  (let [form @(rf/subscribe [:qpe-register/form])
        release-channels @(rf/subscribe [::subs/available-release-channels])]
    (when form
      (let [default-channel (first release-channels)
            form (update-in form [:data :channel] #(or % default-channel))
            {{:keys [location notes installation-token expired expires_at id channel qsm-endpoint
                     proxy-host proxy-port allow-proxy-modification?]
              qpe-name :name :as form-data} :data
             :keys [mode error]} form
            ;; TODO: why do we disable inputs on many occasions? there seems to be no APIs to edit data...
            ;; I would like to change the channel for example, even though installation token exists
            disable-input? (or (#{:delete :edit} mode)
                               installation-token)
            submit-disabled? (case mode
                               :new (or (str/blank? name)
                                        (str/blank? location)
                                        ;; Either both proxy host and port are defined or both are undefined
                                        (and (seq proxy-host) (not (seq proxy-port)))
                                        (and (not (seq proxy-host)) (seq proxy-port)))
                               :edit (or (str/blank? name)
                                         (str/blank? location)
                                         (str/blank? channel)
                                         ;; Either both proxy host and port are defined or both are undefined
                                         (and (seq proxy-host) (not (seq proxy-port)))
                                         (and (not (seq proxy-host)) (seq proxy-port)))
                               :delete true)]
        [layout/sidebar
         [layout/sidebar-header
          {:title (case mode
                    :new "Add new QPE"
                    :delete "QPE registration"
                    "QPE Information")
           :on-close #(rf/dispatch [:qpe-register/close-register-sidebar])}]

         [layout/sidebar-content
          (when error
            [:div.alert.alert-danger
             (:message error)
             (when-some [err (:data error)]
               [:<>
                [:span ": " (:err-msg err)]
                [:div
                 [:code (str (:ex-data err))]]])])

          [:form
           {:on-submit (fn [e]
                         (.preventDefault e)
                         (when (and (= :new mode) (not installation-token))
                           (rf/dispatch [:qpe/register-qpe (update form :data coerse-proxy-config)])))}

           [:div.form-group
            [:label "Name"]
            [:input.form-control
             {:type "text"
              :disabled disable-input?
              :on-change #(rf/dispatch [:qpe-register/set-register-qpe-form-field [:data :name] (.. % -target -value)])
              :value qpe-name}]]

           [:div.form-group
            [:label "Location"]
            [:input.form-control
             {:type "text"
              :disabled disable-input?
              :on-change #(rf/dispatch [:qpe-register/set-register-qpe-form-field [:data :location] (.. % -target -value)])
              :value location}]]

           [:div.form-group
            [:label "Notes"]
            [:textarea.form-control
             {:on-change #(rf/dispatch [:qpe-register/set-register-qpe-form-field [:data :notes] (.. % -target -value)])
              :disabled disable-input?
              :value notes}]]

           [:div.form-group
            [:label "Release channel"]
            [:select.form-select
             {:disabled disable-input?
              :on-change #(rf/dispatch [:qpe-register/set-register-qpe-form-field [:data :channel] (.. % -target -value)])
              :class (when-not channel "is-invalid")
              :value (or channel "")}
             (for [channel-name release-channels]
               ^{:key channel-name}
               [:option {:value channel-name} channel-name])]
            (when (empty? release-channels)
              [:div.invalid-feedback "No release channels available"])]

           [:div.form-group
            [:label "HTTP proxy host"]
            [:input.form-control
             {:type "text"
              :disabled disable-input?
              :on-change #(rf/dispatch [:qpe-register/set-register-qpe-form-field [:data :proxy-host] (str/trim (.. % -target -value))])
              :value proxy-host}]]

           [:div.form-group
            [:label "HTTP proxy port"]
            [:input.form-control
             {:type "number"
              :disabled disable-input?
              :on-change #(rf/dispatch [:qpe-register/set-register-qpe-form-field [:data :proxy-port] (.. % -target -value)])
              :value proxy-port}]]

           [:div.form-group
            [:label "Allow changes to the QPE's proxy configuration after registration"
             [:input.form-check
              {:type      "checkbox"
               :checked   allow-proxy-modification?
               :disabled  disable-input?
               :on-change #(rf/dispatch [:qpe-register/set-register-qpe-form-field [:data :proxy-configuration-ui-access-lock] (.. % -target -checked)])}]]]

           (when (and (= mode :new)
                      (not installation-token))
             [:div.mb-2 "Installation token will be created after submitting registration"])

           (when installation-token
             [:div.border.p-4.mb-2
              (if expired
                [:div
                 [:div.alert.alert-danger "Installation token expired"]
                 [:div.mb-2 "Generate a new installation token or delete this registration, if it is no longer needed"]
                 [:button.btn.btn-outline-primary
                  {:on-click (fn [_]
                               (rf/dispatch [:qpe/refresh-installation-token id]))}
                  "Generate token"]]
                [:div
                 [:dl
                  [:dt
                   "Installation token:"]
                  [:dd
                   [c/copy-text-input
                    {:value installation-token}
                    "Copy"]
                   [:p "Pass this token to qpe-boot or to a started qpe-next instance"]]
                  [:dt
                   "Docker run command"]
                  [:dd
                   [c/copy-text-input
                    {:value (register-qpe-utils/make-docker-run-command qsm-endpoint installation-token proxy-host proxy-port)}
                    "Copy"]
                   [:p "Copy the command to start a qpe-boot with the installation token"]]]
                 [:dl
                  [:dt "Token Expires at"]
                  [:dd (date-time/format-instant expires_at)]]])])

           (when (and (= :edit mode)
                      (= "offline" (:status form-data)))
             [:div
              [:div.alert.alert-secondary
               [:h6 "The QPE is offline."]
               [:p.mb-2.mt-4 "1. To start the qpe, run:"]
               [:code "docker start <qpe-container-name>"]
               [:p.mb-2.mt-4 "2. To remove the qpe, run:"]
               [:code "docker rm <qpe-container-name>"]
               [:p.mb-2.mt-4 "3. To re-install the qpe:"]
               [:p.ml-3 "Click 'Revoke authorization' to generate a new installation token."]]])

           (when (and (= :new mode)
                      (not installation-token))
             [:button.btn.btn-primary
              {:type     "submit"
               :disabled submit-disabled?}
              "Submit"])
           (when (= :delete mode)
             [:button.btn.btn-danger
              {:on-click #(rf/dispatch [:qsm/delete-qpe (:id form-data)])}
              "Delete"])
           (when (or (= :delete mode)
                     (= :edit mode))
             [:button.btn.btn-primary
              {:on-click #(rf/dispatch [:qsm/revoke-authorized (:identity form-data)])
               :title "Removes Engine's current authorization to this QSM and generates new installation token."}
              "Revoke authorization"])]]]))))
